module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/generic-card-d29ec4d0d8078a67e58c8c2c28706aff.svg";